import { render, staticRenderFns } from "./_base-MyModal.vue?vue&type=template&id=b56cc92c&scoped=true"
import script from "./_base-MyModal.vue?vue&type=script&lang=js"
export * from "./_base-MyModal.vue?vue&type=script&lang=js"
import style0 from "./_base-MyModal.vue?vue&type=style&index=0&id=b56cc92c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56cc92c",
  null
  
)

export default component.exports